import React from 'react';
import PropTypes from 'prop-types';

import environment from 'platform/utilities/environment';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import LoginHeader from './LoginHeader';
import LoginActions from './LoginActions';
import LoginInfo from './LoginInfo';

const vaGovFullDomain = environment.BASE_URL;
export const logoSrc = `${vaGovFullDomain}/img/design/logo/va-logo.png`;

export default function LoginContainer({
  clearPreviewEnabled,
  externalApplication,
  isUnifiedSignIn,
  showPasskeyButton,
}) {
  const { useToggleLoadingValue } = useFeatureToggle();
  const isLoadingToggles = useToggleLoadingValue() ?? false;

  if (isLoadingToggles) return null;

  return (
    <section
      className={`login ${isUnifiedSignIn ? 'login-page' : 'login-modal'}`}
    >
      {!isUnifiedSignIn && (
        <div className="row">
          <div className="columns">
            <div className="logo">
              <img
                alt="VA logo and Seal, U.S. Department of Veterans Affairs"
                className="va-header-logo"
                src={logoSrc}
              />
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <LoginHeader />
        <LoginActions
          clearPreviewEnabled={clearPreviewEnabled}
          externalApplication={externalApplication}
          isUnifiedSignIn={isUnifiedSignIn}
          showPasskeyButton={showPasskeyButton}
        />
        <LoginInfo
          clearPreviewEnabled={clearPreviewEnabled}
          externalApplication={externalApplication}
          showPasskeyButton={showPasskeyButton}
        />
      </div>
    </section>
  );
}

LoginContainer.propTypes = {
  clearPreviewEnabled: PropTypes.bool,
  externalApplication: PropTypes.string,
  isUnifiedSignIn: PropTypes.bool,
  showPasskeyButton: PropTypes.bool,
};
